import React from 'react';
import { Crown } from 'lucide-react';

export const LoadingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
      <div className="text-center">
        {/* Chess Pieces Animation */}
        <div className="flex items-center justify-center mb-8 space-x-4">
          {/* Pawn */}
          <div className="animate-bounce" style={{ animationDelay: '0ms' }}>
            <div className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center">
              <div className="w-4 h-4 bg-gray-800 rounded-full border-2 border-white"></div>
            </div>
          </div>
          
          {/* Rook */}
          <div className="animate-bounce" style={{ animationDelay: '150ms' }}>
            <div className="w-8 h-8 bg-gray-800 rounded flex items-center justify-center">
              <div className="w-3 h-3 bg-gray-800 border-2 border-white rounded-sm"></div>
            </div>
          </div>
          
          {/* Queen */}
          <div className="animate-bounce" style={{ animationDelay: '300ms' }}>
            <div className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center">
              <Crown className="h-4 w-4 text-white" />
            </div>
          </div>
          
          {/* King */}
          <div className="animate-bounce" style={{ animationDelay: '450ms' }}>
            <div className="w-8 h-8 bg-gray-800 rounded-full flex items-center justify-center">
              <div className="w-3 h-3 bg-gray-800 border-2 border-white rounded-full relative">
                <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-white rounded-full"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Title with Chess Theme */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center justify-center">
            <Crown className="h-8 w-8 text-primary-600 mr-3" />
            Mirats ChessHub
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-primary-400 to-primary-600 mx-auto rounded-full"></div>
        </div>

        {/* Loading Text */}
        <p className="text-gray-600 mb-8 text-lg">Preparing your chess community...</p>
        
        {/* Enhanced Loading Spinner */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="animate-spin rounded-full h-10 w-10 border-4 border-gray-200"></div>
            <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary-600 border-t-transparent absolute top-0 left-0"></div>
          </div>
        </div>

        {/* Chess Board Pattern */}
        <div className="mt-12 flex justify-center">
          <div className="grid grid-cols-4 gap-1 opacity-20">
            {[...Array(16)].map((_, i) => (
              <div
                key={i}
                className={`w-3 h-3 rounded-sm ${
                  Math.floor(i / 4) % 2 === i % 2 ? 'bg-gray-400' : 'bg-gray-600'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}; 